import { DATETAB_TIME_FORMAT } from '_/config/date';
import { colors, fontSizes, spacing } from '_/constants/theme';
import { formatDate } from '_/helpers/formatDate';
import React, { useCallback, useEffect, useState } from 'react';
import { ActivityIndicator, Dimensions, StyleSheet, View } from 'react-native';
import Modal from 'react-native-modal';

import Avatar from '../Avatar';
import Text from '../Text';
import { useTranslation } from 'react-i18next';
import { usersSlotsApi } from '_/services/api';
import { MembersModel } from '_/services/models/members.model';
import { UsersModel } from '_/services/models/users.model';

interface ModalInterface {
  exclusiveMemberId?: string | boolean;
  onBackdropPress: () => void;
  onBackButtonPress: () => void;
  onSwipeStart: () => void;
  source?: string;
  slotId: string;
  name?: string;
  description?: string;
}

export default function ExclusiveSlotModal({
  exclusiveMemberId,
  slotId,
  onBackdropPress,
  onBackButtonPress,
  onSwipeStart,
}: ModalInterface) {
  const [loading, setLoading] = useState(false);
  const [userMember, setUserMember] = useState<UsersModel | null>(null);
  const { t } = useTranslation();
  const getUsersSlot = useCallback(async (slotId: string) => {
    setLoading(true);

    const result = await usersSlotsApi.getItem(slotId, {
      params: { $filterByMemberId: exclusiveMemberId },
    });
    setUserMember(result.data[0] as unknown as UsersModel);

    setLoading(false);
  }, []);

  useEffect(() => {
    if (exclusiveMemberId) {
      getUsersSlot(slotId);
    }
  }, []);

  return (
    <Modal
      style={styles.modal}
      animationIn="fadeIn"
      animationOut="fadeOut"
      isVisible={!!exclusiveMemberId}
      coverScreen
      hasBackdrop
      backdropOpacity={0.5}
      onBackdropPress={onBackdropPress}
      onBackButtonPress={onBackButtonPress}
      onSwipeStart={onSwipeStart}
    >
      <View style={styles.whoReservedContainer}>
        {loading ? (
          <ActivityIndicator size="large" color={colors.darkPrimary} />
        ) : (
          <View style={styles.userInfo}>
            <Avatar size={40} source={userMember?.pictureThumbUrl || userMember?.pictureUrl} />
            <View style={{ alignItems: 'center', justifyContent: 'center' }}>
              <View style={styles.username}>
                <Text fontType="bold" fontSize={fontSizes.md2}>
                  {userMember?.name}
                </Text>
                <Text fontSize={fontSizes.md} color={colors.black}>
                  {t('workstationScreen.exclusiveSlot')}
                </Text>
              </View>
            </View>
          </View>
        )}
      </View>
    </Modal>
  );
}

const { height } = Dimensions.get('window');

const styles = StyleSheet.create({
  modal: {
    backgroundColor: colors.white,
    borderRadius: 16,
    alignSelf: 'center',
    justifyContent: 'space-between',
    position: 'absolute',
    width: '85%',
    maxWidth: 550,
    height: 80,
    top: height / 2.5,
  },
  whoReservedContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.xs,
    flex: 1,
  },
  userInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  username: {
    alignItems: 'center',
    marginLeft: spacing.sm,
  },
});
